<wr-base-dialog status="info"
                header="Bilder zuweisen"
                submitText="Zuweisen"
                [submitResponse]="onSubmit"
                (close)="onCancel()">
  <p>{{ count }} Bild{{ count === 1 ? '' : 'er' }} einem Gebäudeteil zuweisen:</p>
  <nb-select fullWidth [(selected)]="selectedSectionId">
    <nb-option value="">Unzugewiesen</nb-option>
    @for (section of sections; track section.id) {
      <nb-option [value]="section.id">{{ section.sectionText }}</nb-option>
    }
  </nb-select>
</wr-base-dialog>
